// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileIcon_wrapper__7bDv0","icon":"FileIcon_icon__KTJWu","content":"FileIcon_content__n4vS7","extension":"FileIcon_extension__8Napz"};